"use strict";

var _jsxRuntime = require("react/jsx-runtime");
module.exports = ({
  title,
  titleId,
  size,
  color,
  ...props
}) => /*#__PURE__*/(0, _jsxRuntime.jsxs)("svg", {
  ...props,
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24",
  height: size,
  width: size,
  fill: color,
  role: title ? 'img' : undefined,
  "aria-hidden": !title,
  "aria-labelledby": titleId,
  children: [title ? /*#__PURE__*/(0, _jsxRuntime.jsx)("title", {
    id: titleId,
    children: title
  }) : null, /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
    fillRule: "evenodd",
    d: "M13.134 2h-2a.5.5 0 0 0 0 1h2a.5.5 0 0 0 0-1Zm3.005 0h-.01a.496.496 0 0 0-.495.5c0 .276.23.5.505.5a.5.5 0 0 0 0-1Zm-3.505 20a1 1 0 1 0 0-2 1 1 0 0 0 0 2Zm6.5-5.5a.5.5 0 0 0-.5.5v1h-13V5h13v1a.5.5 0 0 0 1 0V3.5c0-1.93-1.57-3.5-3.5-3.5h-8c-1.93 0-3.5 1.57-3.5 3.5v17c0 1.93 1.57 3.5 3.5 3.5h8c1.93 0 3.5-1.57 3.5-3.5V17a.5.5 0 0 0-.5-.5Zm-13.5-13c0-1.378 1.121-2.5 2.5-2.5h8c1.38 0 2.5 1.122 2.5 2.5V4h-13v-.5Zm13.115 17c0 1.378-1.12 2.5-2.5 2.5h-8a2.503 2.503 0 0 1-2.5-2.5V19h13v1.5ZM11.334 16h-2.4c-.165 0-.3-.1-.3-.222v-3.556c0-.122.135-.222.3-.222h2.4c.166 0 .3.1.3.222v3.556c0 .122-.134.222-.3.222Zm-1.657-.95 1.003-.042-.021-2.054-1.003.041.021 2.054Zm5.657.95h-2.4c-.165 0-.3-.096-.3-.214v-5.572c0-.118.135-.214.3-.214h2.4c.166 0 .3.096.3.214v5.572c0 .118-.134.214-.3.214Zm-1.676-1.02.976.01-.006-4.027-1.001-.001.031 4.017ZM19.334 16h-2.4c-.165 0-.3-.094-.3-.21V8.21c0-.116.135-.21.3-.21h2.4c.166 0 .3.094.3.21v7.58c0 .116-.134.21-.3.21Zm-1.715-1.02 1.054.056-.084-6.033-.904-.062-.066 6.039ZM23.334 16h-2.4c-.165 0-.3-.093-.3-.208V6.208c0-.115.135-.208.3-.208h2.4c.166 0 .3.093.3.208v9.584c0 .115-.134.208-.3.208Zm-1.725-1.038.984.077.026-7.993-.984-.077-.026 7.993Z",
    clipRule: "evenodd"
  })]
});